module.exports = __webpack_public_path__ + "static/media/news_banner_img1_boston.b7337490.png";